import moment from 'moment';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
/**
 * uploadToken 过期时间为1个小时
 */
export function getUploadToken(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_UPLOAD_TOKEN,
		payload,
		callback,
		errorCallback
	};
}
